import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { WISDEN_QUIZ_USER_ID } from 'utils/constants';
import createAxiosInstance from './axiosInstance';
import {
  getGuestUserInfoFromLocalStorage,
  isArraysEqual,
  isUserLoggedIn
} from 'utils/commonFunctions';

// Create separate Axios instances for api and feeds
const apiAxiosInstance = createAxiosInstance(process.env.API_BASE_URL);
const feedsAxiosInstance = createAxiosInstance(process.env.FEEDS_BASE_URL);

const getGuestUserId = () => {
  if (!isUserLoggedIn()) {
    const guestUserInfo = getGuestUserInfoFromLocalStorage();
    // if (!guestUserInfo?.hasPointsMerged) {
    if (
      !guestUserInfo?.hasPointsMerged ||
      !guestUserInfo?.hasPlayed ||
      !isArraysEqual(
        Array.isArray(guestUserInfo?.hasPointsMerged) || [],
        Array.isArray(guestUserInfo?.hasPlayed) || []
      )
    ) {
      return localStorage.getItem(WISDEN_QUIZ_USER_ID);
    }
    return null;
  }
  return null;
};

const axiosBaseQuery =
  (axiosInstance) =>
  async ({ url, method, data, params, headers, ...rest }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers: {
          'Content-Type': 'application/json-patch+json',
          entity: 'ed0t4n$3!',
          'X-UserId': getGuestUserId(),
          // 'X-UserId':
          //   !isUserLoggedIn() &&
          //   !getGuestUserInfoFromLocalStorage()?.hasPlayed &&
          //   !getGuestUserInfoFromLocalStorage()?.hasPointsMerged
          //     ? localStorage.getItem(WISDEN_QUIZ_USER_ID)
          //     : null,

          // 'X-UserId': localStorage.getItem(WISDEN_QUIZ_USER_ID),
          // Authorization: `Bearer  ${isUserLoggedIn() ? localStorage?.getItem('HEADER_TOKEN') : ''}`,
          ...headers // Merge provided headers with default headers
        },
        ...rest
      });
      return { data: result.data, 
               meta: {
                response: result
               } };
    } catch (error) {
      return {
        error: {
          ...error?.data
        }
      };
    }
  };

const baseQueryWithRetry = (axiosInstance) =>
  retry(axiosBaseQuery(axiosInstance), { maxRetries: 0 });

// Create separate base queries with retry for api and feeds
const apiBaseQueryWithRetry = baseQueryWithRetry(apiAxiosInstance);
const feedsBaseQueryWithRetry = baseQueryWithRetry(feedsAxiosInstance);

// Create separate API instances for api and feeds
export const api = createApi({
  reducerPath: 'api',
  baseQuery: apiBaseQueryWithRetry,
  endpoints: () => ({}),
  keepUnusedDataFor: 0,
  refetchOnReconnect: true
});

export const feeds = createApi({
  reducerPath: 'feeds',
  baseQuery: feedsBaseQueryWithRetry,
  endpoints: () => ({}),
  keepUnusedDataFor: 0,
  refetchOnReconnect: true
});
